import React, { useCallback, useEffect, useState } from "react"
import { Redirect } from "react-router"
import SearchBar from "../../components/SearchBar"
import FavoritesSearch from "./views/FavoritesSearch"
import AllFavorites from "./views/AllFavorites"
import FavoritesFolder from "./views/FavoritesFolder"
import { debounce } from "throttle-debounce"

const FavoritesPage = (props) => {
  const { viewer, match, trackingLocation } = props
  const [searchBarValue, setSearchBarValue] = useState("")
  const [searchKeword, setSearchKeyword] = useState("")
  const [folderId, setFolderId] = useState(match.params.folderId || "")

  const updateSearchTextDebounced = useCallback(
    debounce(250, setSearchKeyword),
    []
  )

  useEffect(() => {
    updateSearchTextDebounced(searchBarValue)
  }, [searchBarValue])

  const renderResultsContainer = () => {
    if (folderId) {
      return (
        <FavoritesFolder
          folderId={folderId}
          searchKeyword={searchKeword}
          trackingLocation={`${trackingLocation}: Favorite Folder View`}
        />
      )
    }

    if (!folderId && !searchBarValue) {
      return (
        <AllFavorites
          onViewAllClick={(id) => setFolderId(id)}
          trackingLocation={trackingLocation}
        />
      )
    }

    if (!folderId && searchBarValue) {
      return (
        <FavoritesSearch
          searchKeyword={searchKeword}
          trackingLocation={trackingLocation}
        />
      )
    }
  }

  const renderFavoritesPage = () => {
    return (
      <React.Fragment>
        <div className="filter-container-wrapper">
          <div className="filter-container">
            <SearchBar
              classes={["border", "rounded"]}
              placeholder={folderId ? "Search Folder" : "Search All Favorites"}
              value={searchBarValue}
              onChange={(e) => setSearchBarValue(e.target.value)}
            />
          </div>
        </div>
        {renderResultsContainer()}
      </React.Fragment>
    )
  }
  return (
    <main className="main-content">
      {!viewer.isUserAuthenticated ? (
        <Redirect
          to={{ pathname: "/login", state: { from: props.location.pathname } }}
        />
      ) : (
        renderFavoritesPage()
      )}
    </main>
  )
}

FavoritesPage.defaultProps = {
  trackingLocation: "Favorites Page",
}

export default FavoritesPage
